import { GWidget } from "./GWidget";
import { Selection } from "./selection/Selection";
import { LayoutChangedReason } from "./Const";
import { GBox } from "./GBox";
import { Rectangle } from "../maths/Rectangle";
import { Sprite } from "../display/Sprite";
import { InputManager } from "../events/InputManager";
import { HideFlags } from "../Const";
import { Event } from "../events/Event";
import { UIEvent } from "./UIEvent";
export class GPanel extends GBox {
    constructor(layoutClass, selectionClass) {
        super(layoutClass);
        this._maskContainer = new Sprite();
        this._maskContainer.mouseThrough = true;
        this._maskContainer.hideFlags |= HideFlags.HideAndDontSave;
        this.addChild(this._maskContainer);
        let container = new PanelContainer();
        container.mouseThrough = true;
        container.hideFlags |= HideFlags.HideAndDontSave;
        this._maskContainer.addChild(container);
        this._setContainer(container);
        this._selection = new (selectionClass || Selection)(this);
        this.clipping = true;
    }
    get scroller() {
        return this._scroller;
    }
    set scroller(value) {
        if (this._scroller)
            this._scroller.owner = null;
        this._scroller = value;
        if (value)
            value.owner = this;
    }
    get selection() {
        return this._selection;
    }
    get selectedIndex() {
        return this._selection.index;
    }
    set selectedIndex(value) {
        this._selection.index = value;
    }
    get clipping() {
        return this._clipping;
    }
    set clipping(value) {
        if (this._clipping != value) {
            this._clipping = value;
            if (this._clipping) {
                this.scrollRect = new Rectangle(0, 0, this.width, this.height);
            }
            else
                this.scrollRect = null;
            if (this._scroller)
                this._scroller._processClipping();
        }
    }
    get viewWidth() {
        return this._layout.viewWidth;
    }
    set viewWidth(value) {
        this._layout.viewWidth = value;
    }
    get viewHeight() {
        return this._layout.viewHeight;
    }
    set viewHeight(value) {
        this._layout.viewHeight = value;
    }
    get touchItem() {
        let obj = InputManager.touchTarget;
        if (!obj)
            return null;
        let p = obj.parent;
        while (p != null) {
            if (p == this) {
                if (obj.parent == this)
                    return obj;
                else
                    return null;
            }
            obj = p;
            p = p.parent;
        }
        return null;
    }
    _sizeChanged(changeByLayout) {
        if (this._scrollRect)
            this.scrollRect = this._scrollRect.setTo(0, 0, this.width, this.height);
        if (this._scroller)
            this._scroller._ownerSizeChanged();
        if (changeByLayout)
            this._layout.refresh();
    }
    _panelChildChanged(child) {
        this.setLayoutChangedFlag(LayoutChangedReason.Hierarchy);
    }
    destroy() {
        if (this._scroller)
            this._scroller.destroy();
        if (this._selection)
            this._selection.destroy();
        super.destroy();
    }
}
class PanelContainer extends GWidget {
    _childChanged(child) {
        super._childChanged(child);
        this._parent._parent._panelChildChanged(child);
    }
}
